import React from "react";
import { Box, Card, Typography, IconButton, Tooltip,Button } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person"; // Icon used for the user icon
import { CustomSecondaryButton } from "./GlobalButtonComponent";
export function CustomCardForDashboard ({title="New Leads",value="145",subtitle="12% ↑",icon,darkTheme,lightTheme}) {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: 2,
        border:"1px solid #DFE3EC",
        borderRadius: 2,
       
        width: "100%",
        bgcolor: "white",
      }}
    >
      {/* Icon */}
      <Tooltip title="New leads">
        <IconButton
          disableRipple
          sx={{
            bgcolor: lightTheme, // Active background
            color: darkTheme, // Icon color
            borderRadius: "50%",
          
            padding: 1,
            "&:hover": {
              bgcolor: "rgba(33, 150, 243, 0.2)", // Slightly darker on hover
            },
          }}
        >
          {/* <PersonIcon fontSize="medium" /> */}
          {icon}
        </IconButton>
      </Tooltip>

      {/* Content */}
      <Box mt={2} >
        <Typography
          variant="body2"
          sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: 500 }}
        >
         {title}
        </Typography>
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, color: "rgba(0, 0, 0, 0.87)",display:"inline-block",marginTop:2, }}
        >
          {value}
        </Typography>
        <Box display="flex" alignItems="center"  sx={{border:"1px solid green", bgcolor: "rgba(76, 175, 80, 0.1)", borderRadius: 2,mx:1,p:.5,marginTop:-3,display:"inline-block"}}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color: "green",
              display: "flex",
              alignItems: "center",
              bgcolor: "rgba(76, 175, 80, 0.1)",
              padding: "0px 8px",
             
            }}
          >
         {subtitle}   
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default CustomCardForDashboard;


export function StatusBarClientDashboard({ status = "approved", message, buttonLabel = "Continue", onButtonClick, sx }) {
  const statusStyles = {
    approved: {
      backgroundColor: "#e6f4e6",
      borderColor: "#34a853",
      icon: "✔️",
      title: "Your application is approved",
    },
    pending: {
      backgroundColor: "#fff4e5",
      borderColor: "#fbbc05",
      icon: "⏳",
      title: "Your application is pending",
    },
    rejected: {
      backgroundColor: "#fce8e6",
      borderColor: "#ea4335",
      icon: "❌",
      title: "Your application is rejected",
    },
  };

  const currentStyle = statusStyles[status] || statusStyles.pending;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: currentStyle.backgroundColor,
        border: `1px solid ${currentStyle.borderColor}`,
        borderRadius: 2,
        p: 2,
        ...sx, // Allow custom styles to be passed
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          sx={{
            fontSize: "24px",
            color: currentStyle.borderColor,
            mr: 2,
          }}
        >
          {currentStyle.icon}
        </Typography>
        <Box>
          <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
            {currentStyle.title}
          </Typography>
          <Typography sx={{ color: "text.secondary",width:"80%" }}>{message}</Typography>
        </Box>
      </Box>
      <CustomSecondaryButton label={buttonLabel}/>
    </Box>
  );
}
